<div class="network-container">
  <div class="network-details">
    <ng-container *ngIf="!isLoading; else loadingLabel">
      <span class="network-speed-label">Upload Speed</span>
      <span>{{ networkSpeed }}</span>
      <sn-icon
        *ngIf="networkSpeed !== null && networkSpeed !== undefined && networkSpeed !== '—'"
        [matTooltip]="networkSpeedUpdatedAtToolTip"
        [fontSet]="'far'"
        [fontIcon]="'fa-circle-info'"
        [size]="'sm'"
        [class]="'info-icon'"
      >
      </sn-icon>
    </ng-container>
    <ng-template #loadingLabel>
      <span>Testing upload speed</span>
    </ng-template>
  </div>
  <div class="reload-container" [matTooltip]="reloadButtonToolTip">
    <ng-container *ngIf="!isLoading; else loadingButton">
      <button
        class="reload-button"
        mat-icon-button
        (click)="handleReload()"
        [disabled]="isReloadDisabled"
      >
        <sn-icon
          [fontSet]="'fas'"
          [fontIcon]="'fa-redo'"
          [size]="'sm'"
          [class]="!isReloadDisabled ? 'green-icon' : 'grey-icon'"
        >
        </sn-icon>
      </button>
    </ng-container>
    <ng-template #loadingButton>
      <mat-progress-spinner
        class="reload-button"
        mode="indeterminate"
        diameter="24"
      ></mat-progress-spinner>
    </ng-template>
  </div>
</div>
